import React, { useMemo, useEffect } from "react";
import Helper from "../functions/Helper.js";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../actions/Actions.js";
import DealRow from "./DealRow.js";

function Popup(props) {
  let shoe = props.shoe;

  useEffect(() => {
    if (!shoe.hasOwnProperty("styles")) {
      props.actions.fetch_colorways_and_styles(shoe.shoe_id);
    }
  }, []);

  const PlaceHolder = (props) => {
    let data = [];
    for (var i = 0; i < props.length; i++) {
      data.push(i);
    }

    return (
      <div>
        {data.map((x, index) => (
          <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              padding: "8px 0px",
              borderTopWidth: index === 0 ? 0 : 1,
              borderBottomWidth: index === colorways_by_shop.length - 1 ? 1 : 0,
              borderColor: "#f0f0f0",
              borderStyle: "solid",
            }}
            key={index}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div>
                <div
                  style={{
                    color: "#333333",
                    fontSize: 16,
                    lineHeight: 1.3,
                    fontWeight: 500,
                  }}
                >
                  &nbsp;
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: 2,
                  lineHeight: 1.3,
                  flexDirection: "row",
                }}
              >
                <div style={{ fontWeight: "600" }}>&nbsp;</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                justifyContent: "center",
                alignItems: "flex-end",
              }}
            >
              <a
                target="_blank"
                rel="noopener nofollow"
                href={"#"}
                css={{
                  ":hover": { textDecoration: "none", color: "white" },
                  color: "white",
                  fontWeight: "700",
                  borderRadius: 2,
                  padding: "8px 30px",
                  fontSize: 14,
                  backgroundColor: "#FF5A5F",
                }}
              >
                Buy Now
              </a>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const colorways_by_shop = useMemo(() => {
    if (shoe.hasOwnProperty("colorways_by_shop")) {
      return shoe.colorways_by_shop;
    } else {
      return Helper.sort_colorways_by_shop(shoe.colorways);
    }
  }, [props]);

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <button
        style={{ fontSize: 50, padding: "10px 25px 25px 25px" }}
        className="close"
        type="button"
        data-dismiss="modal"
        aria-label="Close"
        onClick={() => {
          props.hideModal();
        }}
      >
        <span>&times;</span>
      </button>
      <div css={{ padding: 20, "@media (min-width:576px)": { padding: 30 } }}>
        <div
          style={{
            fontSize: 24,
            lineHeight: "1.2",
            padding: "0px 50px 10px 0px",
            fontWeight: "600",
          }}
        >
          Deals for {shoe.shoe_name}
        </div>
        <img
          style={{
            maxWidth: 200,
            width: "100%",
            padding: "30px 0px",
            transform: shoe.pictures[1].mirror === "1" && "scaleX(-1)",
          }}
          alt={shoe.shoe_name}
          sizes="250px"
          srcSet={Helper.create_source_set(shoe.pictures[1])}
        />

        <div style={{ marginTop: 10 }}>
          {colorways_by_shop.length === 0 && (
            <PlaceHolder length={shoe.new_offer.shops} />
          )}

          {colorways_by_shop.map((colorways, index) => {
            return (
              <DealRow
                key={index}
                trackingId={props.prefix}
                colorway={colorways.colorways[0]}
              />
            );
          })}
        </div>
        <div style={{ marginTop: 30, fontSize: 12 }}>
          Support thehoopsgeek.com by clicking and buying from our partner
          shops. We get a small commission for every purchase we refer at no
          additional cost to you!
        </div>
      </div>
    </div>
  );
}

export default connect(null, (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch),
}))(Popup);
